import { render, staticRenderFns } from "./OrderListItemDetail.vue?vue&type=template&id=d672b6f8&scoped=true&"
import script from "./OrderListItemDetail.vue?vue&type=script&lang=js&"
export * from "./OrderListItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderListItemDetail.vue?vue&type=style&index=0&id=d672b6f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d672b6f8",
  null
  
)

export default component.exports